document.addEventListener("DOMContentLoaded", () => {
  const eventAppBlock = document.querySelector('.shopify-app-block form.evey__multi-variant-selector');

  if (eventAppBlock) {
    const addCartBtn = eventAppBlock.querySelector('button[type=submit]');
    if (addCartBtn) {
      addCartBtn.innerHTML = '<span>Ajouter au panier</span>';
    }
    
    const maxTicketsLabel = eventAppBlock.querySelector('.evey__product-message .evey__product-limit');
    maxTicketsLabel.innerHTML = 'Maximum de 12 places par visites';

    if (maxTicketsLabel) {
        const NEW_TEXT = 'Maximum de 12 places par visites';

        const observer = new MutationObserver((mutationsList) => {
            // Check if element is visible (display !== none)
            const isVisible = window.getComputedStyle(maxTicketsLabel).display !== 'none';

            if (!isVisible) return;

            // Only update if needed (prevents loop)
            if (maxTicketsLabel.textContent.trim() !== NEW_TEXT) {

                // Stop observing before modifying (prevents recursion)
                observer.disconnect();

                maxTicketsLabel.textContent = NEW_TEXT;

                // Re-observe after change
                observer.observe(maxTicketsLabel, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                });
            }
        });

        observer.observe(maxTicketsLabel, {
            childList: true,
            subtree: true,
            attributes: true,
        });

        // Optional: also observe parent for visibility toggles
        observer.observe(eventAppBlock, {
            attributes: true,
            attributeFilter: ['style', 'class']
        });
    }
  }
});